import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-request-menu',
  templateUrl: './licence-request-menu.component.html',
  styleUrls: ['./licence-request-menu.component.css']
})
export class LicenceRequestMenuComponent implements OnInit {
  title="Licence Request";
  constructor() { 
    this.showSelected = false;
    this.showSelectedTwo = false;
    this.showSelectedThree = false;
    this.showSelectedFour =false;
    this.showSelectedFive = false;
    this.showSelectedSix = false;
  }
  // 
  showSelected: boolean;
  showSelectedTwo:boolean;
  showSelectedThree:boolean;
  showSelectedFour:boolean;
  showSelectedFive:boolean;
  showSelectedSix:boolean;

  // 
  ShowNewLicense() {
    this.showSelected = true;
    this.showSelectedTwo = false;    
    this.showSelectedThree = false;
    this.showSelectedFour =false;
    this.showSelectedFive = false;
    this.showSelectedSix = false;
 }
 ShowLicenseRenewal(){
  this.showSelectedTwo = true;
  this.showSelected = false;  
    this.showSelectedThree = false;
    this.showSelectedFour =false;
    this.showSelectedFive = false;
    this.showSelectedSix = false;
 }
 ShowPendingLicence(){
  this.showSelected = false;
    this.showSelectedTwo = false;
    this.showSelectedThree = true;
    this.showSelectedFour =false;
    this.showSelectedFive = false;
    this.showSelectedSix = false;
 }
 ShowRejectedLicence(){
  this.showSelected = false;
    this.showSelectedTwo = false;
    this.showSelectedThree = false;
    this.showSelectedFour =true;
    this.showSelectedFive = false;
    this.showSelectedSix = false;
 }
 ShowProvisionally(){
  this.showSelected = false;
    this.showSelectedTwo = false;
    this.showSelectedThree = false;
    this.showSelectedFour =false;
    this.showSelectedFive = true;
    this.showSelectedSix = false;
 }
 ShowAdditionalDistrict(){
  this.showSelected = false;
    this.showSelectedTwo = false;
    this.showSelectedThree = false;
    this.showSelectedFour =false;
    this.showSelectedFive = false;
    this.showSelectedSix = true;
 }

  // 
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/lience-reuest/licence-request-menu/licence-request-menu.component.ts